import dynamic from 'next/dynamic';

const SignalsIcons2x = {
  'form-heart-2x': dynamic(() => import('./FormHeart')),
  'check-2x': dynamic(() => import('./Check')),
  'form-star-2x': dynamic(() => import('./FormStar')),
};

export default SignalsIcons2x;
